import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, Tooltip, Paper } from '@mui/material'
import moment from 'moment/moment'
import { useSelector } from 'react-redux'
import { getVehicleWithDispatchSummaryColumn } from '../common/reportConstants'

const DispatchMiddSection9 = ({
  tableData,
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
}) => {
  const companySettings = useSelector((state) => state?.common?.companySettings)
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const vehicleWIthDispatchSummaryColumn=getVehicleWithDispatchSummaryColumn(UseToPayAsCOD)
  const InsideRowContent = ({ item, index, fontVal }) => {
    return (
      <>
        <TableRow>
          {item.isTotal ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={6}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.PaidUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.TopayUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.OnAccountUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.FocAndSelfUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right', borderRight: '1px solid #aeaeae' }}
              >
                {item.TotalUnits}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.PaidTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.ToPayTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.OnAccountTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.FOCTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.TotalNetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
              >
                {item.BusNumber} {item.SealNo}

              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500', verticalAlign: 'top',
                  textAlign: 'left',
                  whiteSpace: 'pre',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={`${item.Station} ${item.ToBranchName}`} placement="top-start">
                  <span>
                    {item.FromBranchName} <br />
                    {item.FromCityName}
                  </span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500', verticalAlign: 'top',
                  textAlign: 'left',
                  whiteSpace: 'pre',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={`${item.Station} ${item.ToBranchName}`} placement="top-start">
                  <span>
                    {item.Station} <br />
                    {item.ToBranchName}
                  </span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
              >
                {item.DispatchDateTime}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
              >
                {item.DriverConductorContactNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.PaidUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.TopayUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.OnAccountUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.FocAndSelfUnit}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right', borderRight: '1px solid #aeaeae' }}
              >
                {item.TotalUnits}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.PaidTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.ToPayTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.OnAccountTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.FOCTotal}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
              >
                {item.TotalNetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }

  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
        <TableContainer className="scrollBlue" sx={{
          '&::-webkit-scrollbar': { width: '6px', height: '6px' }, border: '1px solid #aeaeae', '& .MuiTableCell-root': {
            fontSize: '14px !important'
          }
        }} component={Paper}>
          <Table className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: '#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: '#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: '#444',
                    height: '36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={4}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {vehicleWIthDispatchSummaryColumn.map((col, index) => (
                  <TableCell
                    key={index}
                    className="ReportItemHead"
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#444',
                      fontSize: '12px',
                      fontWeight: 500,
                      textAlign: col.pdfColSx.halign === 'right' ? 'right' : 'left',
                      whiteSpace: 'pre',
                      borderRight: col.pdfColSx.border || undefined,
                    }}
                    colSpan={1}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={25}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '12px', fontWeight: '500', marginLeft: '5px' }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          <Table style={{ display: "none" }} id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={6}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Vehiclewise Dispatch Report</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={10}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={17}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={2}>From Dispatch Date</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={3}>To Dispatch Date</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={3}>Dispatch By Branch</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={3}>Destination City</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={3}>Destination Branch</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selDestCity?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selBranch?.name}</span>
                </TableCell>

              </TableRow>
              <TableRow>
                <TableCell colSpan={17}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={2}>Vehicle Number</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={2}>Payment Type</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={2}>Report Type</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={2}>Report View</TableCell>
                <TableCell className="ReportItemHead" style={{ backgroundColor: '#bfe1ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }} colSpan={3}>Report Option</TableCell>
              </TableRow>
              <TableRow><TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                colSpan={2}
              >
                <span>{selVehicle?.name}</span>
              </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selPaymentTpe?.name || 'All'}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{reportType?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{showSummaryReport?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{detailedFilter?.Name} </span>
                </TableCell></TableRow>
              <TableRow>
                <TableCell colSpan={25}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ position: 'sticky', top: '0' }}>
              <TableRow>
                <TableCell className="reportTD" style={{ fontWeight: '700', fontSize: '20px', lineHeight: '16px', letterSpacing: '0.24px', textAlign: 'left', color: '#444', height: '36px', backgroundColor: '#bfe1ff' }} colSpan={6}>
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell className="reportTD" style={{ fontWeight: '700', fontSize: '20px', lineHeight: '16px', letterSpacing: '0.24px', textAlign: 'left', color: '#444', height: '36px', backgroundColor: '#bfe1ff' }} colSpan={6}>
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell className="reportTD" style={{ fontWeight: '700', fontSize: '20px', lineHeight: '16px', letterSpacing: '0.24px', textAlign: 'left', color: '#444', height: '36px', backgroundColor: '#bfe1ff' }} colSpan={4}>
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {vehicleWIthDispatchSummaryColumn.map((col, index) => (
                  <TableCell
                    key={index}
                    className="ReportItemHead"
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#444',
                      fontSize: '20px',
                      fontWeight: 600,
                      textAlign: col.pdfColSx.halign === 'right' ? 'right' : 'left',
                      whiteSpace: 'pre',
                      borderRight: col.pdfColSx.border || undefined,
                    }}
                    colSpan={1}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={25}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '20px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{ textAlign: 'center', fontSize: '20px', fontWeight: '500', marginLeft: '5px' }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection9
